module.exports = __webpack_public_path__ + "static/media/logo-comune-biancavilla.13f42728.png";